import React, { useEffect, useState } from 'react';
import { X, Phone } from 'lucide-react';
import { cn } from '../lib/utils';
export const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (isDismissed) return;
      const scrollPosition = window.scrollY + window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
      // Show when scrolled 70% of the page
      if (scrollPosition > totalHeight * 0.7) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);
  if (!isVisible && !isDismissed) return null;
  if (isDismissed) return null;
  return <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 z-[60] animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-204">
      <div className="bg-white text-black p-6 border border-gray-200 shadow-2xl flex flex-col gap-4 max-w-sm relative" data-id="element-205">
        <button onClick={() => setIsDismissed(true)} className="absolute top-4 right-4 text-gray-400 hover:text-black transition-colors" aria-label="Закрити" data-id="element-206">
          <X className="w-5 h-5" data-id="element-207" />
        </button>

        <div data-id="element-208">
          <p className="text-sm font-medium leading-relaxed pr-6" data-id="element-209">
            Створюємо сучасні сайти{' '}
            <span className="font-bold" data-id="element-210">БЕЗКОШТОВНО</span>, обслуговування
            всього 650 грн / місяць.
          </p>
        </div>

        <div className="flex flex-col gap-3 pt-2 border-t border-gray-100" data-id="element-211">
          <a href="https://jetly.agency/ua/sale" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-black text-white px-4 py-3 text-sm font-bold hover:bg-gray-800 transition-colors" data-id="element-212">
            Дізнатись деталі
          </a>
          <a href="tel:+380502276199" className="flex items-center justify-center gap-2 w-full border border-gray-200 text-black px-4 py-3 text-sm font-bold hover:bg-gray-50 transition-colors" data-id="element-213">
            <Phone className="w-4 h-4" data-id="element-214" />
            +38 050 227 61 99
          </a>
        </div>
      </div>
    </div>;
};